import {
    WGCWX_SHOP_PRODUCTS_REQUEST,
    WGCWX_SHOP_PRODUCTS_SUCCESS,
    WGCWX_SHOP_PRODUCTS_ERROR,

    WGCWX_SHOP_PURCHASE_REQUEST,
    WGCWX_SHOP_PURCHASE_SUCCESS,
    WGCWX_SHOP_PURCHASE_ERROR,
    WGCWX_SHOP_CLEAR_ERROR,
} from 'state/actions/wgcwx_shop'

const defaultState = {
    loading: false,
    processing: false,
    errorMessage: null,
    errorActionType: null,
    goods: null,
    accountInfo: {},
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
    case WGCWX_SHOP_PRODUCTS_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: null,
            errorActionType: null,
        }
    }
    case WGCWX_SHOP_PRODUCTS_SUCCESS: {
        return {
            ...state,
            loading: false,
            goods: action.payload.goods,
            accountInfo: action.payload.accountInfo,
        }
    }
    case WGCWX_SHOP_PRODUCTS_ERROR: {
        return {
            ...state,
            loading: false,
            errorMessage: action.payload.errorMessage,
            errorActionType: action.payload.errorActionType,
        }
    }
    case WGCWX_SHOP_CLEAR_ERROR: {
        return {
            ...state,
            errorMessage: null,
            errorActionType: null,
        }
    }
    case WGCWX_SHOP_PURCHASE_REQUEST: {
        return {
            ...state,
            processing: true,
            errorMessage: null,
            errorActionType: null,
        }
    }
    case WGCWX_SHOP_PURCHASE_SUCCESS: {
        return {
            ...state,
            processing: false,
        }
    }
    case WGCWX_SHOP_PURCHASE_ERROR: {
        return {
            ...state,
            processing: false,
            errorMessage: action.payload.errorMessage,
            errorActionType: action.payload.errorActionType,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/products.js